export enum VerificationQuestionTypeEnum{
    SingleSelect = 0,
    MultiSelect = 1,
    FreeText = 2,
    SingleSelectOrFreeText = 3,
    MultiSelectAndOrFreeText = 4
}